import React from "react";
import "../styles/footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 Lak Derana Cabs — Reliable Rides Since 2009</p>
    </footer>
  );
}
